jQuery(document).ready(function($) {
	let wrapper = $('.slideshow-wrapper.default')
	wrapper.each(function() {
		let length = $(this).find('.slideshow-wrapper__item').length
		if (length > 2)
			$(this).slick({
				dots: true,
				autoplay: true,
				arrows: false,
				infinite: true,
				speed: 500,
				autoplaySpeed: 4000,
				fade: true
			})
		else if (length == 2)
			$(this).addClass('two-images')
	})
})
